/// 統合「メンバー」画面 API クライアント。ACC-7 (#361)。
///
/// 担当者マスタ (`/api/admin/accounts` 系) に Auth0 相関を足した read と、Auth0 ロール
/// 変更の write。招待 / 無効化 / 再有効化は `@shared/api/accounts` を併用する。

import type { Member, ChangeMemberRoleRequest } from '@shared/types/member';
import type { AdminRole } from '@shared/types/admin';
import { api } from './client';

/// 担当者全件 + Auth0 在籍相関 (admin 専用)。`organizationId` を渡すとその org の member だけに
/// 絞った統一ビューを返す (組織詳細画面)。未指定は role 由来の既定スコープ (メンバー画面)。
export function listMembers(organizationId?: string): Promise<Member[]> {
  const query = organizationId
    ? `?organization_id=${encodeURIComponent(organizationId)}`
    : '';
  return api.get<Member[]>(`/api/admin/members${query}`);
}

/// 担当者の Auth0 ロールを変更する (Auth0 org member role 置換 + admin_changed 記録)。
export function changeMemberRole(id: string, body: ChangeMemberRoleRequest): Promise<void> {
  return api.put<void>(`/api/admin/accounts/${encodeURIComponent(id)}/role`, body);
}

/// 担当者の現在の Auth0 ロール群を取得する (ロール変更ダイアログの初期選択用)。
/// 現在付与されている全 role_id を返し、複数ロールを温存させる (差分置換で消えるのを防ぐ)。
export function getMemberRoles(accountId: string, organizationId: string): Promise<AdminRole[]> {
  return api.get<AdminRole[]>(
    `/api/admin/accounts/${encodeURIComponent(accountId)}/member-roles?organization_id=${encodeURIComponent(organizationId)}`,
  );
}

/// invited な担当者の招待を取り消す (invited 行の「招待取消」アクション)。
export function cancelInvitation(id: string, organizationId: string): Promise<void> {
  return api.post<void>(`/api/admin/accounts/${encodeURIComponent(id)}/cancel-invitation`, {
    organization_id: organizationId,
  });
}

/// 担当者を Auth0 組織から除名する (Auth0 org membership のみ削除; super_admin 専用)。
export function removeMemberFromOrg(id: string, organizationId: string): Promise<void> {
  return api.post<void>(`/api/admin/accounts/${encodeURIComponent(id)}/remove-from-org`, {
    organization_id: organizationId,
  });
}
